













import Vue from 'vue';

import Actions from '@/components/actions.vue';;

export default Vue.extend({
    components: {
        action: Actions,
    },
    props: {
        topword: String,
        title: String,
        bodytext: String,
        buttons: Array
    }
})
